import React from "react";
import "../../App.css";
import IntroSection from "../IntroSection";
import Footer from "../Footer";
import HomePageFaqs from "./HomePageFaqs";
import Register from "../register/Register";
import Feature from "./Feature";
import PricingComparison from "./PricingComparison";
import PaymentTable from "./PaymentTable";
import Blogs from "./Blogs";
import Header from "./Header";
import StackedCards from "./StackedCards";
import "../../App.css";

import ScrollTriggerComponent from "./ScrollTriggerComponent";
import RevealContent from "./RevealContent";
import FeedbackContainer from "../FeedbackContainer";
import SetupSteps from "./SetupSteps";
import ProblemAndSolution from "./ProblemAndSolution";
import { motion } from "framer-motion";

function Home() {
  const fadeInVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.8 } },
  };

  return (
    <div className="top-0 left-0 w-full">
      {/* Header Section */}
      <Header />

      {/* Problem and Solution Section */}
      <motion.div
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.2 }}
        variants={fadeInVariants}
      >
        <ProblemAndSolution />
      </motion.div>

      {/* Feature Section */}
      <motion.div
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.2 }}
        variants={fadeInVariants}
      >
        <Feature />
      </motion.div>

      {/* Setup Steps Section */}
      <motion.div
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.2 }}
        variants={fadeInVariants}
      >
        <SetupSteps />
      </motion.div>
      {/* Register Section */}
      <motion.div
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.2 }}
        variants={fadeInVariants}
      >
        <Register />
      </motion.div>
      {/* Feedback Section */}
      <motion.div
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.2 }}
        variants={fadeInVariants}
      >
        <FeedbackContainer />
      </motion.div>

      {/* FAQ Section */}
      <motion.div
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.2 }}
        variants={fadeInVariants}
      >
        <HomePageFaqs />
      </motion.div>
    </div>
  );
}

export default Home;
